import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
import useHeadingActions from './useHeadingActions';
import useLinkActions from './useLinkActions';
export default function useKeyboardShortcuts(quill) {
    const linkActions = useLinkActions(quill);
    const headingActions = useHeadingActions(quill);
    // Register keyboard shortcuts
    useEffectWithCtx(ctx => {
        if (quill) {
            // Keyboard shortcut for Triggering Link
            quill.keyboard.addBinding({
                key: 'k',
                metaKey: true,
                handler() {
                    ctx.linkActions.triggerEdit();
                },
            });
            // Paragraph (Ctrl+0 / Cmd+0)
            quill.keyboard.addBinding({
                key: '0',
                shortKey: true,
                handler() {
                    ctx.headingActions.applyHeading(false);
                },
            });
            // Heading 1-6 (Ctrl+1-6 / Cmd+1-6)
            for (let level = 1; level <= 6; level++) {
                quill.keyboard.addBinding({
                    key: level.toString(),
                    shortKey: true,
                    handler() {
                        ctx.headingActions.applyHeading(level);
                    },
                });
            }
        }
    }, { linkActions, headingActions }, [quill]);
}
